import React from 'react'

const Tag = (props) => {
  const { item, filterType, buttonHandler, noClose } = props;
  return (
    <div className='filter-button'>
      <div>
        <p>{item.title}</p>
      </div>
      {
        !noClose &&
        <i className='far fa-times-circle filter-button-icon' onClick={() => buttonHandler(item, filterType)}></i>
      }
    </div>
  )
}

export default Tag;